import React, { Fragment, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import Draggable from "react-draggable";

const ModalHeader = (props) => {
  return (
    <div
      className={`mu-modal-header ${props.className || ""}`}
      style={{
        cursor: props.draggable ? "move" : "default",
        ...props.styles,
      }}
    >
      <h5 className="mu-modal-title">{props.header}</h5>
    </div>
  );
};

const ModalBody = (props) => {
  return (
    <div
      className={`mu-modal-body ${props.className || ""}`}
      style={props.styles}
    >
      {props.children}
    </div>
  );
};

const ModalFooter = (props) => {
  return (
    <div
      className={`mu-modal-footer ${props.className || ""}`}
      style={props.styles}
    >
      {props.children}
    </div>
  );
};

const Modal = ({
  header,
  footer,
  children,
  onShow,
  overlayToggle,
  centered,
  toggle,
  size,
  fullScreen,
  draggable = false,
  headerStyle,
  bodyStyle,
  footerStyle,
  overlayStyle,
  ModalStyle,
  headerClassname = "",
  bodyClassname = "",
  footerClassname = "",
  ModalClassname = "",
}) => {
  const [onModalShow, setOnModalShow] = useState(onShow);
  const [onAnimateModalShow, setOnAnimateModalShow] = useState(false);
  const nodeRef = useRef(null);
  useEffect(() => {
    if (!onShow) {
      setOnAnimateModalShow(false);

      setTimeout(() => {
        setOnModalShow(false);
      }, 200);
    }

    if (onShow) {
      setOnModalShow(true);
      setOnAnimateModalShow(true);
    }
  }, [onShow]);

  const modalContent = (
    <div
      ref={nodeRef}
      className={`mu-modal-content ${fullScreen ? "mu-modal-content-fullscreen" : ""
        }`}
    >
      {header && (
        <ModalHeader
          header={header}
          styles={headerStyle}
          className={headerClassname}
        />
      )}

      {toggle && (
        <div className="mu-modal-close" onClick={toggle}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z" />
          </svg>
        </div>
      )}

      {children && (
        <ModalBody
          styles={bodyStyle}
          className={bodyClassname}
        >
          {children}
        </ModalBody>
      )}

      {footer && (
        <ModalFooter
          styles={footerStyle}
          className={footerClassname}
        >
          {footer}
        </ModalFooter>
      )}
    </div>
  );

  return createPortal(
    <div className={draggable ? "pointer-events-close" : ""}>
      {onModalShow && (
        <div className="mu-modal-wrapper">
          {!draggable && (
            <div
              onClick={overlayToggle}
              className={`mu-modal-overlay ${onAnimateModalShow ? "mu-fade-modal" : "mu-fade-reverse"
                }`}
              style={overlayStyle}
            />
          )}

          {/* <div
            className={`mu-modal ${
              onAnimateModalShow
                ? "mu-fade-modal"
                : "mu-fade-reverse"
            } 
            ${centered ? "mu-modal-centered" : ""}
            ${size ? `mu-modal-${size}` : "mu-modal-sm"}
            ${fullScreen ? "mu-modal-fullscreen" : ""}
            ${ModalClassname}`}
            style={ModalStyle}
          >
            {draggable ? (
              <Draggable handle=".mu-modal-header">
                {modalContent}
              </Draggable>
            ) : (
              modalContent
            )}
          </div> */}
          <div
            className={`mu-modal ${onAnimateModalShow ? "mu-fade-modal" : "mu-fade-reverse"
              } ${centered ? "mu-modal-centered" : ""} ${size ? `mu-modal-${size}` : "mu-modal-sm"
              } ${fullScreen ? "mu-modal-fullscreen" : ""} ${ModalClassname}`}
            style={ModalStyle}
          >
            {/* {draggable ? (
              <Draggable
                nodeRef={nodeRef}
                handle=".mu-modal-header"
              >
                {modalContent}
              </Draggable>
            ) : (
              modalContent
            )} */}
            {/* {draggable ? (
              <Draggable nodeRef={nodeRef}>
                {modalContent}
              </Draggable>
            ) : (
              modalContent
            )} */}
            {draggable ? (
  <Draggable
    nodeRef={nodeRef}
    cancel="button, input, textarea, select, option, a, img"
  >
    {modalContent}
  </Draggable>
) : (
  modalContent
)}
          </div>
        </div>
      )}
    </div>,
    document.body
  );
};

export default Modal;